import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSucessResponse } from "../../utils/API/responseMiddleware";

const rejectedReasonAPI = createApi({
    reducerPath: 'rejectedReasonAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        addRejectedReason: builder.mutation({
            query: (details) => ({
                url: '/RejectedReason/AddRejectedReason',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getRejectedReasonList: builder.mutation({
            query: (details) => ({
                url: '/RejectedReason/GetRejectedReasonList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateRejectedReason: builder.mutation({
            query: (details) => ({
                url: '/RejectedReason/UpdateRejectedReason',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        })

    })
})

export const {
    useAddRejectedReasonMutation,
    useGetRejectedReasonListMutation,
    useUpdateRejectedReasonMutation,
} = rejectedReasonAPI;
export default rejectedReasonAPI;